import React, { useState } from 'react';
import OrangeButton from '../buttons/orange-button';
import OrangeButtonOutline from '../buttons/orange-button-outline';
import { useNavigate } from 'react-router-dom';

const SupportSection = () => {
  const navigate = useNavigate();
  const [showSignupModal, setShowSignupModal] = useState(false);

  return (
    <div className="mx-auto !mt-[48px] flex flex-col-reverse items-center gap-4 md:!mt-[96px] md:gap-12 lg:flex-row ">
      <div className="container w-full !max-w-[502px] space-y-4 !px-6 md:!pr-0 ">
        <div className="fredokaOne text-[32px] font-normal leading-normal tracking-[-0.8px] text-[#012E33] md:text-[40px] ">
          Direct Messaging & Support
        </div>

        <p className="fredoka mt-6 text-[18px] font-normal leading-[145.55%] tracking-[-0.18px] text-[#678285] md:text-[22px]    md:tracking-[-0.22px] ">
          Integrated messaging system providing VIP, white-glove service from our support team.
        </p>

        <div className="flex flex-col gap-4 pt-4 lg:flex-row">
          <OrangeButton
            className="fredokaOne !rounded-2xl"
            onClick={() => setShowSignupModal(true)}
            label={'Become an IAMAI VIP Tutor Now'}
          />
          <OrangeButtonOutline
            onClick={() => navigate('/products/academic-tutoring')}
            label={'Learn More'}
          />
        </div>
      </div>
      <div className="w-full pl-4 lg:w-1/2 lg:p-0">
        <img src="/images/home/In-App-Chat-Support-Preview.png" alt="" />
      </div>
    </div>
  );
};

export default SupportSection;
